// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"128":"fcf1f5ecd0e16d58","5310":"b3a1381318bcc0d2","7911":"ff58c1563dacbae1"}[chunkId] + ".js";
};